import styled from 'styled-components'

export const GlobalSearchTriggerButtonStyled = styled.button.attrs({
  type: 'button',
  'data-analytics-id': 'global-search-trigger-button',
})`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.typography.pxToRem(12)};
  flex: 0 1 ${(props) => props.theme.typography.pxToRem(460)};
  margin: 0 auto;

  height: ${(props) => props.theme.typography.pxToRem(40)};
  padding: 0 ${(props) => props.theme.typography.pxToRem(12)};

  background: ${(props) => props.theme.colors.content.contentBackground};
  border: 1px solid ${(props) => props.theme.colors.globalCommand.border};
  border-radius: ${(props) => props.theme.typography.pxToRem(20)};
  transition: border-color 0.15s ease;

  font-family: inherit;
  font-size: ${(props) => props.theme.typography.pxToRem(14)};
  line-height: 1;
  color: ${(props) => props.theme.colors.globalCommand.text};
  cursor: pointer;

  &:hover {
    border-color: ${(props) => props.theme.colors.form.field.borderActive};
  }

  &:focus-visible {
    border-color: ${(props) => props.theme.colors.focus};
    outline: ${(props) =>
      `${props.theme.typography.pxToRem(1)} solid ${props.theme.colors.focus}`};
  }

  &:focus:not(:focus-visible) {
    outline: none;
  }
`
